import {HQ_USER_TYPE, HQ_COMPANY_TYPE, HQ_ROLE_TYPE} from '../constants/hq-types';

const enhanceEntityObject = (entity, oxygenType) => Object.assign({}, entity, {oxygenType});

const enhanceUserEntityObject = adminUser =>
  Object.assign({}, adminUser, {
    oxygenType: HQ_USER_TYPE,
    oxygenId: adminUser.oxygenId ?? adminUser.autodeskId,
    eaUserId: adminUser.eaUserId || adminUser.hqId || adminUser.id,
    id: adminUser.oxygenId ?? adminUser.autodeskId,
    projectStatus: adminUser.projectStatus ?? adminUser.status,
    isProjectAdmin: adminUser.isProjectAdmin ?? adminUser.accessLevels?.projectAdmin,
    company: adminUser.company?.id ? adminUser.company : undefined,
    roles: adminUser.roles ? adminUser.roles : undefined,
    profileImg50: adminUser.profileImg50 || adminUser.imageUrl
  });

export const buildOxygenObjects = (oxygen, state) => {
  const {users = [], companies = [], roles = []} = oxygen;
  const {users: prevUsers = {}, companies: prevCompanies = {}, roles: prevRoles = {}} = state || {};

  // We only handle used roles (used = a user in the project is assigned to them)
  let usedRoles = [];
  [...Object.values(prevUsers), ...users].forEach(user => {
    usedRoles = usedRoles.concat(user.roleIds || user.roles.map(role => role.eaRoleId));
  });
  const tempCompanies = [...Object.values(prevCompanies), ...companies].reduce((result, value) => {
    result[value.eaCompanyId] = value;
    return result;
  }, {});
  const tempRoles = [...Object.values(prevRoles), ...roles].reduce((result, value) => {
    result[value.eaRoleId] = value;
    return result;
  }, {});

  return {
    users: users.reduce((result, value) => {
      const user = enhanceUserEntityObject(value);
      user.company = user.company || tempCompanies[user.companyId] || {};
      user.rolesMap =
        user.roleIds?.reduce((rolesMapper, roleId) => {
          rolesMapper[roleId] = tempRoles[roleId];
          return rolesMapper;
        }, {}) || {};
      result[user.oxygenId] = user;
      return result;
    }, prevUsers),
    companies: companies.reduce((result, value) => {
      const company = enhanceEntityObject(value, HQ_COMPANY_TYPE);
      result[company.oxygenId] = company;
      return result;
    }, prevCompanies),
    roles: [...Object.values(prevRoles), ...roles].reduce((result, value) => {
      const role = enhanceEntityObject(value, HQ_ROLE_TYPE);

      // Mark role as in project in case needed, this will be used in our selectors for filtering
      if (usedRoles.includes(value.eaRoleId)) {
        role.isInProject = true;
      }

      result[role.oxygenId] = role;

      return result;
    }, {})
  };
};
